module.exports = __webpack_public_path__ + "static/bg_fallback-1f666e1643df131e8e9db15b7ed1414b.jpg";